import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, TextArea, Form } from "semantic-ui-react";

const ComposeBox = ({ onSend, disabled }) => {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    const trimmed = message.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setMessage("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="wa-compose-box">
      <Form className="wa-compose-box__form">
        <TextArea
          className="wa-compose-box__input"
          placeholder="Type a message... (Enter to send, Shift+Enter for new line)"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          rows={2}
        />
        <Button
          className="wa-compose-box__send"
          primary
          onClick={handleSend}
          disabled={!message.trim() || disabled}
          icon="send"
        />
      </Form>
    </div>
  );
};

ComposeBox.propTypes = {
  onSend: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ComposeBox;
